import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Box, Container, Typography, IconButton } from '@mui/material'

import { useHistory } from 'react-router-dom'
import useIsMobile from '../../../../../hooks/useIsMobile'
import useTranslations from '../../../../../i18n/useTranslations'

import LinkBack from '../../../../../ui/components/LinkBack'
import CopyTextButton from '../../../../../ui/components/CopyTextButton'
import StatusCodeChip from '../../../../../ui/components/chip/StatusCodeChip'
import { ReactComponent as X } from '../../../../../assets/icons/x.svg'

import styles from '../../styles'
import ReferenceAndUpdateDate from './ReferenceAndUpdateDate'
import ShippingConfigChips from './ShippingConfigChips'

const BasicInfoSection = ({ data, state }) => {
  const history = useHistory()
  const t = useTranslations()

  const isMobile = useIsMobile()

  const BasicInfoContent = isMobile ? Container : Box
  const reverseOrReturnShipping =
    data?.info?.relatedReturn?.returnShippingCode ??
    data?.info?.relatedReturn?.reverseReturnShippingCode

  return (
    <Box component="section" sx={styles.summary}>
      <BasicInfoContent>
        {isMobile ? (
          <>
            {data.info.pickupUnscheduled ? (
              <StatusCodeChip
                size="medium"
                state={{
                  lastStatusDescription: t('tracking-line:pickup-unscheduled'),
                  severity: 'yellow',
                }}
                hasIncident={state?.length ? state[0]?.incidentCode : null}
                isCancelled={data?.info?.isCancelled}
              />
            ) : (
              <StatusCodeChip
                size="medium"
                incidentDesc={state[0].incidentDescription}
                state={state?.length ? state[0] : null}
                hasIncident={state?.length ? state[0]?.incidentCode : null}
                isCancelled={data?.info?.isCancelled}
              />
            )}
            <IconButton onClick={history.goBack} sx={styles.closeButton}>
              <X />
            </IconButton>
          </>
        ) : (
          <LinkBack sx={styles.linkBack}>{t('action:back')}</LinkBack>
        )}

        <Box sx={isMobile ? styles.summaryNumberWrapperM : styles.summaryNumberWrapper}>
          <Box sx={styles.numberBox}>
            <Typography variant="h1" sx={styles.summaryNumber}>
              {t('shipping-detail:shipment-number')} {data.info.shippingCode}
            </Typography>
            <CopyTextButton textToCopy={data.info.shippingCode} />
          </Box>
          {data?.info?.cttPrimeShippingCode ? (
            <Box sx={styles.numberBox}>
              <Typography variant="h3" sx={styles.summaryNumber}>
                {data.info.cttPrimeShippingCode}
              </Typography>
              <CopyTextButton textToCopy={data.info.cttPrimeShippingCode} />
            </Box>
          ) : null}
        </Box>

        {data.info.relatedReturn.originalShippingCode && (
          <Box sx={styles.summaryNumberWrapper}>
            <Typography variant="h3" sx={styles.summaryNumber}>
              <Link
                to={`/shippings-tracking/${data.info.relatedReturn.originalShippingCode}`}
              >
                {t('shipping-detail:original-number')}{' '}
                {data.info.relatedReturn.originalShippingCode}
              </Link>
              <CopyTextButton
                textToCopy={data.info.relatedReturn.originalShippingCode}
              />
            </Typography>
          </Box>
        )}

        {reverseOrReturnShipping && (
          <Box sx={styles.summaryNumberWrapper}>
            <Typography variant="h3" sx={styles.summaryNumber}>
              <Link to={`/shippings-tracking/${reverseOrReturnShipping}`}>
                {t('shipping-detail:return-number')} {reverseOrReturnShipping}
              </Link>
              <CopyTextButton textToCopy={reverseOrReturnShipping} />
            </Typography>
          </Box>
        )}

        {isMobile && (
          <ReferenceAndUpdateDate
            clientReference={data.info.clientReference}
            shippingStatusDatetime={data.info.shippingStatusDatetime}
          />
        )}
        <ShippingConfigChips
          numberOfPackages={data.shipment?.packages?.length}
          serviceType={data?.info?.bestShippingTypeCode}
          totalWeight={data.info?.shippingWeight}
          services={data.services}
        />
      </BasicInfoContent>
    </Box>
  )
}

BasicInfoSection.propTypes = {
  data: PropTypes.object,
  state: PropTypes.object,
}

export default BasicInfoSection
